import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export interface ContactInfo {
  transactionId: string | undefined | null;
  fullName: string | undefined | null;
  salutation: string | undefined | null;
  mobileNumber: string | undefined | null;
  email: string | undefined | null;
  dateOfBirth: string | undefined | null;
  product: "EVERGREEN";
  rentalPostalCustomer: string | undefined | null;
  agentCode: string | undefined | null;
  dropPoint: "QNB_SPE_CONTACTUS";
  cc: string | undefined | null;
}

interface IinitialState {
  contactInfo: ContactInfo;
}

const initialState: IinitialState = {
  contactInfo: {
    transactionId: "",
    fullName: "",
    salutation: "",
    mobileNumber: "",
    email: "",
    dateOfBirth: null,
    product: "EVERGREEN",
    rentalPostalCustomer: "",
    agentCode: null,
    dropPoint: "QNB_SPE_CONTACTUS",
    cc: null,
  },
};

const contactSlice = createSlice({
  name: "Ever_Green_Contact",
  initialState,
  reducers: {
    updateContactDetail: (
      state,
      action: PayloadAction<Partial<ContactInfo>>
    ) => {
      state.contactInfo = {
        ...state.contactInfo,
        ...action.payload,
      };
    },
  },
});

export const { updateContactDetail } = contactSlice.actions;

export default contactSlice.reducer;
